import { BaseComponent } from '../../base-component';

export class WishlistBtnComponent extends BaseComponent {
    public rootSelector = '.js_pdp_wishlist-btn';

    public async init(): Promise<void> {
        return;
    }

    public async onHtmlLoaded(): Promise<void> {
        if (!this.isPresent()) return;

        this.getButtonElement().addEventListener('click', () => this.handleButtonClickEvent());
    }

    public handleButtonClickEvent(): void {
        const variationId = this.getButtonElement().dataset.variationId;
        if (variationId) {
            this.addToWishlist(variationId);
            this.showMessage();
            this.setWishlistButtonToActiveState();
        }
    }

    public addToWishlist(variationId: string): void {
        o_global.eventQBus.emit('ft1.wishlist.add', {
            variationId,
            addedFrom: 'ProductDetailPage',
            qualified: true,
        });
    }

    private setWishlistButtonToActiveState(): void {
        const iconUseElement = this.getButtonElement();
        if (!iconUseElement) return;

        iconUseElement.setAttribute('icon-type-left', 'wishlist-active');
    }

    private showMessage(): void {
        o_global.eventQBus.emit('assets.snackbar.trigger', {
            text: 'Gespeichert!',
            actionLinkText: 'Merkzettel anzeigen',
            actionFunction: () => {
                window.location.href = '/wishlist-view/';
            },
        });
    }

    private getButtonElement(): HTMLButtonElement {
        return this.getChildElement('.js_pdp_wishlist-btn__button') as HTMLButtonElement;
    }
}
